import { Component } from 'react';

class Button extends Component {
  render() {
    return this.props.children;
  }
}

export default Button;
